import * as React from 'react';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { brandingDarkTheme, brandingLightTheme } from './brandingTheme';
import { jsx as _jsx } from "react/jsx-runtime";
export function BrandingProvider(props) {
  var children = props.children,
    modeProp = props.mode;
  var upperTheme = useTheme();
  var mode = modeProp || upperTheme.palette.mode;
  var theme = mode === 'dark' ? brandingDarkTheme : brandingLightTheme;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: modeProp ? function () {
      return theme;
    } : theme,
    children: children
  });
}